/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Earningssortlabel2Inputs */

const en_earningssortlabel2 = /** @type {(inputs: Earningssortlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sort by`)
};

const de_earningssortlabel2 = /** @type {(inputs: Earningssortlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sortieren nach`)
};

/**
* | output |
* | --- |
* | "Sort by" |
*
* @param {Earningssortlabel2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const earningssortlabel2 = /** @type {((inputs?: Earningssortlabel2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earningssortlabel2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earningssortlabel2(inputs)
	return de_earningssortlabel2(inputs)
});
export { earningssortlabel2 as "earningsSortLabel" }